<template>
  <div>
    <!-- Header -->
    <AppHeader />

    <!-- Hero Section -->
    <section class="hero hero-eastern">
      <div class="container">
        <div class="hero-content fade-in-up">
          <h1>Стоимость занятий</h1>
          <p>отличается от количества человек в группе, а также пакета купленный уроков за раз</p>
        </div>
      </div>
    </section>

    <!-- Pricing Section -->
    <UISection>
      <template #default>
        <div class="pricing-main-grid">
          <!-- Индивидуально -->
          <div class="pricing-main-card">
            <div class="pricing-main-header">
              <h2>Индивидуально</h2>
              <div class="pricing-subtitle">1 на 1 с преподавателем</div>
              <div class="pricing-divider"></div>
            </div>
            <ul class="pricing-main-features">
              <li>самый эффективный способ обучения</li>
              <li>подготовка к экзаменам, либо достижения других поставленных целей</li>
              <li>удобный утвержденномый вами график</li>
              <li>при оплане нескольких занятий сразу – скидки</li>
            </ul>
            <div class="pricing-main-price">
              <div class="price-large">от <strong>11 400 ₽/8 занятий</strong></div>
              <div class="price-small">от 1425 <strong>₽</strong>/занятие</div>
            </div>
          </div>

          <!-- В группе -->
          <div class="pricing-main-card">
            <div class="pricing-main-header">
              <h2>В группе</h2>
              <div class="pricing-subtitle">2-3 человека</div>
              <div class="pricing-divider"></div>
            </div>
            <ul class="pricing-main-features">
              <li>Отличный способ сэкономить, если вас несколько человек</li>
              <li>В небольшой группе эффективность обучения сохраняется</li>
              <li>Скидка в 50% на каждого дополнительного человека</li>
            </ul>
            <div class="pricing-main-price">
              <div class="price-large">50% от стоимости</div>
            </div>
          </div>
        </div>

        <div class="pricing-motivation">
          <p>Ставьте перед собой цели и добивайтесь их вместе с нами! Будь то сдача экзамена HSK или удивить иностранного бизнес партнера.</p>
        </div>

        <div class="pricing-note">
          <p>Цены актуальны при покупке абонемента на 8 занятий. При оплате каждого занятия отдельно стоимость будет немного выше.</p>
          <p>Итоговая стоимость также может отличаться в зависимости от сложности вашей цели и уровня преподавателя.</p>
        </div>
      </template>
    </UISection>

    <!-- Testimonials Section -->
    <section v-if="priceReviews.length > 0" class="testimonial">
      <div class="container">
        <div class="testimonial-header">
          <h2 class="testimonial-title">Отзывы учеников</h2>
          <router-link to="/reviews" class="testimonial-link">
            Все отзывы <span aria-hidden="true">→</span>
          </router-link>
        </div>
        <div class="testimonials-grid">
          <div class="testimonial-card" v-for="review in priceReviews" :key="review.id">
            <div class="testimonial-text">
              "{{ review.text }}"
            </div>
            <div class="testimonial-author">{{ review.student_name }}</div>
          </div>
        </div>
      </div>
    </section>

    <!-- CTA Section -->
    <section class="cta-section">
      <div class="container">
        <p>Напишите нам в любой удобный для вас мессенджер, мы ответим на все интересующие вас вопросы и согласуем бесплатный пробный 30-минутный урок.</p>
        <UIButton to="/contacts#contact-methods">Связаться с нами</UIButton>
      </div>
    </section>

    <!-- Footer -->
    <UIFooter />
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue'
import UIButton from '@/components/ui/UIButton.vue'
import UISection from '@/components/ui/UISection.vue'
import UIFooter from '@/components/ui/UIFooter.vue'
import axios from 'axios'

const api = axios.create({
  baseURL: '/api/v1'
})

export default {
  name: 'PricesPage',
  components: {
    AppHeader,
    UIButton,
    UISection,
    UIFooter
  },
  data() {
    return {
      priceReviews: []
    }
  },
  mounted() {
    this.loadReviews()
    this.setupAnimations()
    
    // Smooth scrolling for navigation links
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        e.preventDefault();
        const target = document.querySelector(this.getAttribute('href'));
        if (target) {
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    });
  },
  methods: {
    async loadReviews() {
      try {
        const { data } = await api.get('/public/reviews/random', {
          params: { count: 2 }
        })
        this.priceReviews = data || []
        // После загрузки отзывов обновляем observer для новых элементов
        this.$nextTick(() => {
          this.setupAnimations()
        })
      } catch (err) {
        console.error('Не удалось загрузить отзывы для страницы цен', err)
        this.priceReviews = []
      }
    },
    setupAnimations() {
      // Add animation on scroll
      const observerOptions = {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      };

      const observer = new IntersectionObserver(function(entries) {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('fade-in-up');
          }
        });
      }, observerOptions);

      document.querySelectorAll('.pricing-main-card, .testimonial-card').forEach(el => {
        observer.observe(el);
      });
    }
  }
}
</script>

<style scoped>
.nav-menu a.active {
  color: #e74c3c;
}

.pricing-main-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 3rem;
  margin-top: 3rem;
  margin-bottom: 3rem;
}

.pricing-main-card {
  background: white;
  padding: 3rem;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.08);
  transition: all 0.3s ease;
  border: 1px solid #f1f3f4;
}

.pricing-main-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 30px rgba(0,0,0,0.12);
}

.pricing-main-header h2 {
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
  color: #2c3e50;
}

.pricing-subtitle {
  font-size: 1.1rem;
  color: #6c757d;
  margin-bottom: 1.5rem;
  font-weight: 500;
}

.pricing-divider {
  width: 60px;
  height: 3px;
  background: #e74c3c;
  margin-bottom: 2rem;
}

.pricing-main-features {
  list-style: none;
  padding: 0;
  margin-bottom: 2rem;
}

.pricing-main-features li {
  padding: 0.75rem 0;
  color: #495057;
  line-height: 1.6;
  position: relative;
  padding-left: 1.5rem;
}

.pricing-main-features li::before {
  content: '•';
  color: #e74c3c;
  font-weight: bold;
  position: absolute;
  left: 0;
}

.pricing-main-price {
  text-align: center;
  padding-top: 2rem;
  border-top: 1px solid #e9ecef;
}

.price-large {
  font-size: 1.5rem;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 0.5rem;
}

.price-small {
  font-size: 1.1rem;
  color: #6c757d;
}

.pricing-note {
  margin: 0;
  padding: 1.5rem 2rem;
  background: #fff8f7;
  border-left: 4px solid #e74c3c;
  border-radius: 8px;
  color: #495057;
  line-height: 1.6;
}

.pricing-note p {
  margin: 0;
}

.pricing-note p + p {
  margin-top: 0.5rem;
}

.pricing-motivation {
  text-align: center;
  margin: 3rem 0;
  padding: 2rem;
  background: #f8f9fa;
  border-radius: 12px;
}

.pricing-motivation p {
  font-size: 1.2rem;
  color: #495057;
  line-height: 1.6;
  margin: 0;
}

.testimonial-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2.5rem;
}

.testimonial-title {
  margin: 0;
  color: #2c3e50;
  font-size: 2.2rem;
  font-weight: 700;
  line-height: 1.3;
  text-align: left;
}

.testimonial-title::after {
  content: '';
  display: block;
  width: 64px;
  height: 3px;
  margin-top: 10px;
  border-radius: 2px;
  background: linear-gradient(90deg, #e74c3c, #c0392b);
}

.testimonial-link {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
  padding: 0.7rem 1.1rem;
  color: #e74c3c;
  background: #ffffff;
  border: 1px solid rgba(231, 76, 60, 0.45);
  border-radius: 999px;
  text-decoration: none;
  font-weight: 600;
  transition: color 0.2s ease, background-color 0.2s ease, border-color 0.2s ease, transform 0.2s ease;
}

.testimonial-link:hover {
  color: #ffffff;
  background: #e74c3c;
  border-color: #e74c3c;
  transform: translateY(-1px);
}

.testimonials-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 2rem;
}

.testimonial-card {
  background: #ffffff;
  padding: 2.25rem;
  border-radius: 15px;
  border: 1px solid #e9ecef;
  box-shadow: 0 8px 24px rgba(44, 62, 80, 0.08);
}

.testimonial-text {
  font-size: 1.1rem;
  font-style: italic;
  margin-bottom: 1.5rem;
  line-height: 1.8;
  color: #495057;
}

.testimonial-author {
  font-weight: 600;
  font-size: 1rem;
  color: #e74c3c;
}

@media (max-width: 768px) {
  .pricing-main-grid {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
  
  .pricing-main-card {
    padding: 2rem;
  }

  .pricing-note {
    padding: 1.25rem 1.5rem;
  }

  .testimonial-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }

  .testimonial-title {
    font-size: 1.8rem;
  }
  
  .testimonials-grid {
    grid-template-columns: 1fr;
  }
}
</style>
